import {
  lightThemeMonday,
  darkThemeMonday,
  blackThemeMonday,
} from './themeMonday';
import { lightThemeJIRA } from './themeJIRA';
import { lightThemeAzure, darkThemeAzure } from './themeAzure';
import { HostPlatform, Azure, JIRA, Monday } from '../config/hostPlatform';

const themes = [
  [
    Azure,
    {
      lightTheme: lightThemeAzure,
      darkTheme: darkThemeAzure,
      blackTheme: blackThemeMonday,
    },
  ],
  [
    JIRA,
    {
      lightTheme: lightThemeJIRA,
      darkTheme: lightThemeJIRA,
      blackTheme: lightThemeJIRA,
    },
  ],
  [
    Monday,
    {
      lightTheme: lightThemeMonday,
      darkTheme: darkThemeMonday,
      blackTheme: blackThemeMonday,
    },
  ],
] as const;

// @ts-ignore
const Platforms = new Map(themes);

const theme = Platforms.get(HostPlatform.activeId) || themes[2][1];

const { lightTheme, darkTheme, blackTheme } = theme;

export { lightTheme, darkTheme, blackTheme };

export { default as GlobalStyle } from './GlobalStyle';
